import styled from "styled-components";
import Colors from "../../Constant/Colors";
import { FONTS, STYLES } from "../../Constant/Theme";

export const HorizontalAlign = styled.div`
  ${STYLES.HorizontalAlign}
`;
export const HorizontalLeftAlign = styled.div`
  ${STYLES.HorizontalLeftAlign}
`;

export const SpaceBetween = styled.div`
  ${STYLES.spaceBetween};
  width: 100%;
`;

export const VerticalAlign = styled.div`
  ${STYLES.VerticalAlign}
`;
export const VerticalSpaceBetween = styled.div`
  ${STYLES.verticalSpaceBetween};
  height: 100%;
`;


export const VerticalLeftAlign = styled.div`
  ${STYLES.VerticalLeftAlign}
`;


export const TruncatedText = styled.div`
 display: -webkit-box;
  -webkit-line-clamp: 1; /* Number of lines to show */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RegSmPri = styled.p`
  ${FONTS.Regular12};
  color: ${Colors.primary};
  margin: 0px;
`;

export const RegMedPri = styled.p`
  ${FONTS.Regular14};
  color: ${Colors.primary};
  margin: 0px;
`;
export const RegLgPri = styled.p`
  ${FONTS.Regular16};
  color: ${Colors.primary};
  margin: 0px;
`;

export const BoldSmPri = styled.p`
  ${FONTS.Bold12};
  color: ${Colors.primary};
  margin: 0px;
`;

export const BoldMedPri = styled.p`
  ${FONTS.Bold14};
  color: ${Colors.primary};
  margin: 0px;
`;
export const BoldLgPri = styled.p`
  ${FONTS.Bold16};
  color: ${Colors.primary};
  margin: 0px;
`;
export const BoldSm = styled.p`
  ${FONTS.Bold12};
  margin: 0px;
`;
export const BoldMed = styled.p`
  ${FONTS.Bold14};
  margin: 0px;
`;
export const BoldLg = styled.p`
  ${FONTS.Bold16};
  margin: 0px;
`;
export const BoldHeading = styled.p`
  margin: 0px;
   ${FONTS.Bold20};
`;
export const BoldHeadingPri = styled.p`
  margin: 0px;
   ${FONTS.Bold20};
  color: ${Colors.primary};

`;


export const RegSm = styled.p`
  margin: 0px;
  ${FONTS.Regular12};
`;
export const RegMed = styled.p`
  margin: 0px;
  ${FONTS.Regular14};
`;
export const RegLg = styled.p`
  margin: 0px;
  ${FONTS.Regular16};
`;
